import '../assets/css/loader.css'

const Preloader = () => {
  return (
    <div className='loader-glistening-window'></div>
  );
}

export default Preloader;
